import React,{useEffect,useState} from "react";
import { Link,useNavigate,NavLink } from "react-router-dom";
import AxiosServices from "../../networks/AxiosService";
import ApiUrlServices from "../../networks/ApiUrlServices";
import {toast} from 'react-toastify';
import AnchorButton from "../../component/button/AnchorButton";
import CourseRating from "../../component/CourseRating/CourseRating";
import {useTranslation} from "react-i18next";
import {userData} from "../../config/sessionKeys"
import path from '../../routes/path'
import {cloudfront_base_url} from "../../config/config";
import siteConfig from "../../config/site-config";
import SelectonEnrolldStudenetCourseCard from '../../component/Skeleton/SelectonEnrolldStudenetCourseCard'
import { returnNumberByLang } from "../../helper/CommonFunctions"
import './EnrolldStudentList.scss'
import Student from "./img/Student.svg";
import StudentActive from "./img/StudentActive.svg";
import Certificate from "./img/Certificate.svg";
import CertificateActive from "./img/CertificateActive.svg";

const qs = require('query-string');
const EnrolldStudentCourseCard = () => {
    const  { t } = useTranslation();
    const navigate = useNavigate()
    const parsed = qs.parse(window.location.search);
    const [loading,setLoading] = useState(false);
    const [courseData, setCourseData] = useState({});
    const [courseStatData,setCourseStatData] = useState('')
    const sessionKeyUserData = JSON.parse(localStorage.getItem(userData));
    useEffect(() => {
        singleCourseData()
    }, []);

    const singleCourseData = () => {
        setLoading(true)
        const userId = sessionKeyUserData.userId
        const payload = {
            status: window.location.search?.includes('status') ? window.location.search?.split('=')?.pop() : 'published',
            check_enrolled: false,
        };
        AxiosServices.post(ApiUrlServices.GET_COURSE_DETAILS(parsed.slug),payload)
            .then(res=>{
                console.log(res.data.data)
                if (userId !== res.data.data.mentor_id) {
                    toast.error(`${t('ALL_MESSAGE.you_are_not_authorized_to_see_this_page')}`);
                    navigate(path.view_instructor_course);
                }
                setCourseData(res.data.data);
                setCourseStatData(res.data.data.stat);
                setLoading(false)
            })
            .catch(err=>{
                console.log(err)
                setLoading(false)
            })
    }
    const backOneStep = () => {
        navigate(`${process.env.PUBLIC_URL}${path.view_instructor_course}?page=1`);
    }
    return(
        <>
            <div className="enroll-student-list-wrapper">
                <div className="add-new-courses-url">
                    <button onClick={()=>backOneStep()} className={"back-btn-coursewise"}><i className="bi bi-chevron-left" /> {t('course_enroll_student.back')}</button>
                    <Link to={`${process.env.PUBLIC_URL}${path.course_create}`}><i className="bi bi-plus-lg"></i> {t('profile.add_new_course')}</Link>
                </div>
                <div className="courses-content-section mb-40 mt-20">

                    {loading?<SelectonEnrolldStudenetCourseCard />:
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-5 col-6">
                                <div className="thumb">
                                    <img src={courseData.thumbnail ? cloudfront_base_url + courseData.thumbnail : siteConfig.default_course_thum} alt={courseData.course_name} />
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-7 col-6 align-self-center">
                                <div className="content">
                                    <h3>{courseData.course_name} </h3>
                                    <p>{courseData.course_description_summery}</p>
                                    <div className="details-rating">
                                        <AnchorButton
                                            btnText={t('courses_card.view_details')}
                                            to={`${process.env.PUBLIC_URL}${path.courses_details}/${courseData.slug}`}
                                        />
                                        <div className="rating-l">
                                            <CourseRating ratingWidth={Math.round(courseStatData.rating) * 20} />
                                            <span>({Number(courseStatData.total_review_count) > 0 ? `${t('number_translate', { count: returnNumberByLang(Number(Math.round(courseStatData?.total_review_count)))})}`: `${t('number_translate', { count: returnNumberByLang(0)})}`})</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
                <ul className="nav tab-style-2">
                    <li className="nav-item">
                        <NavLink to={`${path.view_instructor_course}/${courseData.course_id}?page=1&slug=${courseData.slug}`} className={"nav-link"}>
                            <img src={Student} />
                            <img className="active" src={StudentActive} />
                            {t('course_enroll_student.total_students')}
                            <span></span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`${path.enroll_course_certificate_list}${courseData.course_id}?page=1&slug=${courseData.slug}`} className={"nav-link"}>
                            <img src={Certificate} />
                            <img className="active" src={CertificateActive} />
                            {t('course_enroll_student.awaiting_certificate')}
                            <span></span>
                        </NavLink>
                    </li>
                </ul>
            </div>
        </>
    )
}
export  default EnrolldStudentCourseCard;